// ============================================================
// CLOUD FUNCTIONS CLIENT (scheduled reports)
// ============================================================
//
// Mirrors the existing pattern already used for Paddle cancellation in
// SubscriptionContext.js: a plain authenticated fetch() to an HTTPS Cloud
// Function, rather than pulling in the firebase/functions SDK for a
// single call. Keeping that same pattern here (instead of introducing a
// new calling convention) is deliberate — see the top-level deliverables
// notes for why.

const SEND_TEST_REPORT_FUNCTION_URL =
  "https://us-central1-insightpulse-ai-5960.cloudfunctions.net/sendTestScheduledReport";

// Sends a one-off test copy of a schedule's report to the caller's own
// verified account email (enforced server-side — see functions/index.js).
// Never alters the schedule's real nextRunAt.
export async function sendTestScheduledReport(scheduleId, idToken) {
  const response = await fetch(SEND_TEST_REPORT_FUNCTION_URL, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ scheduleId }),
  });

  const result = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(result?.error || "Failed to send test report");
  }

  return result;
}
